import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import {
  fetchBank,
  fetchStaffGrade,
} from "../../../../features/dropdown/dropdownSlice";

const { TextArea } = Input;

const AddBankBranchModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { bank, loading } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!formData?.jbbJbnkCode) {
      toast.error("Please select bank");
      return;
    }
    const res = await dispatch(
      save({
        jbbCode: formData?.jbbCode,   
        jbbJbnkCode:formData?.jbbJbnkCode,
        jbbBranchName: formData?.jbbBranchName,
        
        jbbRefCode: formData?.jbbRefCode,
        jbbPhysicalAddrs: formData?.jbbPhysicalAddrs,
        jbbPostalAddrs: formData?.jbbPostalAddrs,
        jbbShtDesc: formData?.jbbShtDesc,
        url: "hr/saveBankBranch.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchBankData() {
    dispatch(fetchBank());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit branch ${prodd?.spPositionname}`
            : "Add bank branch details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="grid grid-cols-2 gap-x-5"> 
          <Form.Item
            className=""
            label={<span>Bank</span>}
            rules={[
              {
                required: true,
                message: "Please select bank",
              },
            ]}
          >
              
            <Select
              name="jbbJbnkCode"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                bank?.length > 0 &&
                bank?.map((item) => ({
                  value: item?.jbnkId,
                  label: item?.jbnkBankName,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "jbbJbnkCode");
              }}
              value={formData?.jbnkBankName}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchBankData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            label="Branch Name"
            rules={[
              {
                required: true,
                message: "Enter Branch Name",
              },
            ]}
          >
            <Input
              required
              name="jbbBranchName"
              onChange={onChange}
              value={formData?.jbbBranchName}
              className="input"
            />
          </Form.Item>

          
          <Form.Item
            label="Branch Code"
            rules={[
              {
                required: true,
                message: "Enter Branch Code",
              },
            ]}
          >
            <Input
             readOnly={prodd?.jbbCode ? true : false}
              required
              name="jbbCode"
              onChange={onChange}
              value={formData?.jbbCode}
              className="input"
            />
          </Form.Item>
          <Form.Item
            label="Reference"
            rules={[
              {
                required: true,
                message: "Enter reference",
              },
            ]}
          >
            <Input
              required
              name="jbbRefCode"
              onChange={onChange}
              value={formData?.jbbRefCode}
              className="input"
            />
          </Form.Item>

          <Form.Item
            label="Physical Address"
            rules={[
              {
                required: false,
                message: "Enter Physical Address",
              },
            ]}
          >
            <Input 
              name="jbbPhysicalAddrs"
              onChange={onChange}
              value={formData?.jbbPhysicalAddrs}
              className="input"
            />
          </Form.Item>
          <Form.Item
            label="Postal Address"
            rules={[
              {
                required: false,
                message: "Enter Postal Address",
              },
            ]}
          >
            <Input 
              name="jbbPostalAddrs"
              onChange={onChange}
              value={formData?.jbbPostalAddrs}
              className="input"
            />
          </Form.Item>
          </div>
          <Form.Item
            label="Short Description"
            rules={[
              {
                required: true,
                message: "Enter short description",
              },
            ]}
          >
            <TextArea
              required
              rows={6}
              name="jbbShtDesc"
              onChange={onChange}
              value={formData?.jbbShtDesc}
              className="input"
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddBankBranchModal;
